export default "__VITE_ASSET__9a386033__"